import { z } from 'zod';
import { v4 as uuidv4 } from 'uuid';
import {
  NavrhUzneseniaVladyFormData,
} from '../../../../model/sprievodnyDokument/navrhUzneseniaVlady/NavrhUzneseniaVladyFormData';
import { ClientStatus } from '../../../../model/ClientStatus';
import { useClientFetch } from '../../../../context/ClientStatusContext';
import getFormData from '../../../../function/getFormData';
import { FormDataResponse } from '../../../../model/sprievodnyDokument/FormDataResponse';
import fallback from '../../../../function/zodFallback';
import Uuid from '../../../../model/Uuid';

const ResponseBod = z.object({
  zodpovednaOsoba: fallback(z.string(), ''),
  text: fallback(z.string(), ''),
  termin: fallback(z.string(), ''),
});

const ResponseCast = z.object({
  zamerCasti: fallback(z.string(), ''),
  bodList: fallback(z.array(ResponseBod), []),
});

const Response = z.object({
  nazovMaterialu: fallback(z.string(), ''),
  cisloMaterialu: fallback(z.string(), ''),
  predkladatel: fallback(z.string(), ''),
  castList: fallback(z.array(ResponseCast), []),
  vykonaju: fallback(z.string(), ''),
  naVedomie: fallback(z.string(), ''),
});

export function mapNavrhUzneseniaVladyFormData(rawFormData: object, isUznesenie: boolean): NavrhUzneseniaVladyFormData {
  const response = Response.parse(rawFormData);

  return {
    isUznesenie,
    nazovMaterialu: response.nazovMaterialu,
    cisloMaterialu: response.cisloMaterialu,
    predkladatel: response.predkladatel,
    castList: response.castList.map(x => ({
      bodList: x.bodList.map(y => ({
        uuid: uuidv4(),
        zodpovednaOsoba: y.zodpovednaOsoba,
        text: y.text,
        termin: y.termin,
      })),
      uuid: uuidv4(),
      zamerCasti: x.zamerCasti,
    })),
    vykonaju: response.vykonaju,
    naVedomie: response.naVedomie,
  };
}

interface ReturnType {
  formDataResponse: FormDataResponse<NavrhUzneseniaVladyFormData>,
  formDataStatus: ClientStatus,
}

export default (
  type: string,
  year: number,
  index: number,
  typKod: string,
  stadiumUuid: Uuid,
): ReturnType => {
  const {
    data,
    status,
  } = useClientFetch(
    getFormData,
    [type, year, index, typKod, stadiumUuid],
    [],
  );
  return {
    formDataResponse: data ? {
      formData: mapNavrhUzneseniaVladyFormData(data.formData, typKod === 'UznesenieVladySR'),
      materialDetail: data.materialDetail,
    } : null,
    formDataStatus: status,
  };
};
